module.exports = __webpack_public_path__ + "img/index-bottom-ball.dbf16aaf.png";